module.exports = __webpack_public_path__ + "media/images/mypage/mymenu_2-a9570ca1af882343280a68d85834861e.gif";